<template>
  <v-flex xs12 sm6 md3
  :class="paddingClass">
    <v-autocomplete
      v-model.trim="userId"
      :search-input.sync="search"
      cache-items
      :loading="isLoading"
      :items="users"
      item-text="value"
      item-value="id"
      placeholder="Wpisz imię i/lub nazwisko"
      hide-no-data
      clearable
      flat
      label="Właściciel"
    ></v-autocomplete>
  </v-flex>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getUserFilterList } from '../../../repository/users/index';

export default {
  name: 'search-by-user',
  data: () => ({
    userId: null,
    users: [],
    search: null,
    isLoading: false,
    descriptionLimit: 60,
  }),
  computed: {
    ...mapGetters('files', [
      'query',
    ]),
    clientId() {
      const { params } = this.$route;
      return params.clientId;
    },
    isSearchPage() {
      return this.$route.name === 'searchFiles';
    },
    singleParams() {
      return {
        client_id: this.clientId,
      };
    },
    paddingClass() {
      return this.$vuetify.breakpoint.xs ? 'px-0' : 'pr-3';
    },
  },
  methods: {
    ...mapActions('files', [
      'setQuery',
    ]),
    async getFilterList(searchValue) {
      this.isLoading = true;
      try {
        const usersFilterList = await getUserFilterList({ name: searchValue, role: 'admin' });
        this.isLoading = false;
        this.users = usersFilterList.data.data.items;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.getFilterList();
  },
  watch: {
    search(val) {
      const isInList = this.users.find(item => item.value === val);
      if (val && !isInList) {
        this.getFilterList(val);
      }
    },
    userId(id) {
      if (!this.isSearchPage) {
        this.setQuery(null);
      }
      const newQuery = {
        ...this.query,
      };
      if (id) {
        newQuery.owner_id = id;
      } else {
        delete newQuery.owner_id;
      }
      this.setQuery(newQuery);
      this.$router.push({ path: `/pliki/klient/${this.clientId}/szukaj`, query: newQuery });
    },
  },
};
</script>
